import { sensor } from "@/store";

export default function () {
    const GetStatus = () => {
        sensor.GetPowerStatus();
    };
    const turnOn = (id: string) => {
        sensor.SetDeviceStatus({ id, status: true });
    };
    const turnOff = (id: string) => {
        sensor.SetDeviceStatus({ id, status: false });
    };
    return {
        GetStatus,
        turnOn,
        turnOff,
    };
}
